import { FormField } from '@cashier/cashier-model';
import { useUIConfiguration } from '@cashier/cashier-shared';
import { InputGenerator } from '@cashier/cashier-ui';

import {
  useCashierConfiguration,
  useFieldToucher,
  useFormPayloadItem,
} from '../../../../hooks';

interface ComponentProps {
  field: FormField;
  version: 'v2' | 'v3';
}

export const StandardField = ({ field, version }: ComponentProps) => {
  const { name } = field;

  const { touch } = useFieldToucher();
  const { direction } = useCashierConfiguration();

  const { validationStatus, isDisabled } = useFormPayloadItem(name);
  const inputLabelPosition = useUIConfiguration('input', 'label');

  return (
    <InputGenerator
      direction={direction}
      labelPosition={inputLabelPosition}
      field={field}
      validationStatus={validationStatus}
      isDisabled={isDisabled}
      onChange={(value: string, isFocused: boolean) =>
        touch({ ...field, value }, { interactionCompleted: !isFocused })
      }
    />
  );
};
